import { render, staticRenderFns } from "./SalesFlyerSideMenuContents.vue?vue&type=template&id=2a996ab9"
import script from "./SalesFlyerSideMenuContents.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerSideMenuContents.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerSideMenuContents.vue?vue&type=style&index=0&id=2a996ab9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports